import React from 'react';
import { useParams } from 'react-router-dom';
import SeasonSuperlatives from '../../components/analytics/SeasonSuperlatives';

const LeagueAwards: React.FC = () => {
  const { espnLeagueId } = useParams<{ espnLeagueId: string }>();

  return (
    <SeasonSuperlatives leagueId={parseInt(espnLeagueId!) || 0} />
  );
};

export default LeagueAwards;